import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useWarehouseList = () => useQuery({ queryKey: ['warehouse-list'], queryFn: async () => {
    const callback = await API.get(`/warehouse`)
    return callback?.data
},staleTime: 1000 * 60 * 60, gcTime: 1000 * 60 * 60 * 24 })

export default useWarehouseList